module.exports = __webpack_public_path__ + "img/05.f7a6c728.png";